// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"0a6acdcc","650":"8b4283ce"}[chunkId] + ".chunk.css";
};